import React, { useEffect, useState } from "react";

const FIELD_LABELS = {
  date_of_service: "Date of Service",
  ndc: "NDC-11",
  quantity: "Quantity",
  service_provider_id: "Service Provider ID",
  id_340b_raw: "340B ID",
  health_plan_id: "Health Plan ID",
  health_plan_name: "Health Plan Name",
  claim_number: "Claim Number",
  claim_line_number: "Claim Line Number",
  unit_of_measure: "Unit of Measure",
  hcpcs_code: "HCPCS Code",
  hcpcs_code_modifier_1: "HCPCS Code Modifier 1",
  hcpcs_code_modifier_2: "HCPCS Code Modifier 2",
  hcpcs_code_modifier_3: "HCPCS Code Modifier 3",
  hcpcs_code_modifier_4: "HCPCS Code Modifier 4",
  rendering_physician_id: "Rendering Physician ID",
  wholesaler_invoice_number: "Wholesaler Invoice Number",
  // begin encounter fields
  encounter_date_of_service: "Encounter Date of Service",
  encounter_billing_service_provider_id: "Encounter Billing Service Provider ID",
  encounter_place_of_service_code: "Encounter Place of Service Code",
  encounter_rendering_physician_id: "Encounter Rendering Physician ID",
  encounter_hcpcs_code: "Encounter HCPCS Code",
  encounter_hcpcs_code_modifier_1: "Encounter HCPCS Code Modifier 1",
  encounter_hcpcs_code_modifier_2: "Encounter HCPCS Code Modifier 2",
  encounter_hcpcs_code_modifier_3: "Encounter HCPCS Code Modifier 3",
  encounter_hcpcs_code_modifier_4: "Encounter HCPCS Code Modifier 4",
  encounter_diagnosis_code_primary: "Encounter Primary Diagnosis Code",
  encounter_diagnosis_code_2: "Encounter Diagnosis Code 2",
  encounter_diagnosis_code_3: "Encounter Diagnosis Code 3",
  encounter_diagnosis_code_4: "Encounter Diagnosis Code 4",
  encounter_diagnosis_code_5: "Encounter Diagnosis Code 5",
  encounter_diagnosis_code_6: "Encounter Diagnosis Code 6",
  encounter_diagnosis_code_7: "Encounter Diagnosis Code 7",
  encounter_diagnosis_code_8: "Encounter Diagnosis Code 8",
  encounter_diagnosis_code_9: "Encounter Diagnosis Code 9",
  encounter_diagnosis_code_10: "Encounter Diagnosis Code 10",
};

const MedicalEncounterClaimHistory = ({ historyPath }) => {
  const [historyLines, setHistoryLines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(historyPath, {
          headers: {
            Accept: "application/json",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
        });
        const data = await response.json();
        setHistoryLines(data.history || []);
      } catch (error) {
        console.error("Failed to fetch history:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [historyPath]);

  if (isLoading) {
    return <div className="t--sm t--subtitle pa--8">Loading history...</div>;
  }

  if (historyLines.length === 0) {
    return null;
  }

  return (
    <div className="tile pa--8">
      <div className="flex align-center gap--8 mb--12">
        <span className="t--sm t--500 t--upcase">Claim History</span>
        <span className="t--sm t--blue">{historyLines.length} submissions</span>
      </div>

      <div className="claim-detail__history-heading">
        <div className="t--xsm t--500 t--upcase" style={{ width: "25%" }}>
          Submitted On
        </div>
        <div className="t--xsm t--500 t--upcase" style={{ width: "25%" }}>
          Submission Name
        </div>
        <div className="t--xsm t--500 t--upcase" style={{ width: "25%" }}>
          Submitted By
        </div>
        <div className="t--xsm t--500 t--upcase" style={{ width: "25%" }}>
          Issues
        </div>
      </div>

      {historyLines.map((history, index) => (
        <div
          key={index}
          className={`claim-detail__timeline-entry${history.not_considered ? " claim-detail__timeline-entry--faded" : ""}`}
        >
          <div className="claim-detail__timeline-content">
            <div className="claim-detail__timeline-row">
              <div className="t--sm t--500">{history.date_submitted}</div>
              <div className="t--sm">{history.submission_name}</div>
              <div className="t--sm">{history.submitted_by}</div>
              <div className="t--sm">
                {history.issues && history.issues.length > 0 ? history.issues.join(", ") : "--"}
              </div>
            </div>

            {history.differences &&
              history.differences.length > 0 &&
              history.differences.map((diff, i) => (
                <div key={i} className="claim-detail__diff">
                  <span>{FIELD_LABELS[diff.column_name] || diff.column_name} was changed from</span>
                  <span className="badge">{diff.previous_value || <em>empty</em>}</span>
                  <span>to</span>
                  <span className="badge">{diff.current_value || <em>empty</em>}</span>
                </div>
              ))}

            {history.final && historyLines[index + 1] && (
              <div className="claim-detail__final-notice">
                {history.conforming
                  ? "A conforming claim has already been submitted. Subsequent resubmissions are not considered."
                  : "Maximum resubmissions reached. Subsequent resubmissions are not considered."}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MedicalEncounterClaimHistory;
